import {
  Form, FormRow, List, ListItem, Option, PopupHint, Row, SegmentedButton, ValidInput} from '@op/opds.opux';
import { IconLike } from '@op/opds.opux-icons/action';
import React, { useEffect } from 'react';
import { FormInput } from '../common/Input/FormInput';
import { Message, useLocales, useMessageGetter } from '@messageformat/react';
import { IO_CHANGE_CONTACTINFO } from '../../constants/actionTypes';
import { useInsuranceOffer } from '../../hooks';
import ValidationError from '../common/ValidationError/ValidationError';

const ContactInfo = ({searchCustomer}) => {
  const { state, validateContactInfo } = useInsuranceOffer();
  const contactDetails = state.contactInfo;
  const getMessage = useMessageGetter();
  const [language] = useLocales();
  const isEnglish = !(language === 'sv' || language === 'fi');

  contactDetails.fullNameID = 'CONTACT_BASICDETAILFULLNAME';
  contactDetails.firstNameID = 'CONTACT_BASICDETAILFIRSTNAME';
  contactDetails.lastNameID = 'CONTACT_BASICDETAILLASTTNAME';
  contactDetails.idNumberID = 'CONTACT_BASICDETAILSSECURITYID';
  contactDetails.addressID = 'CONTACT_BASICDETAILSADDRESS';
  contactDetails.postCodeID = 'CONTACT_BASICDETAILPOSTCODE';
  contactDetails.postID = 'CONTACT_BASICDETAILSPOST';
  contactDetails.phoneNumberID = 'CONTACT_BASICDETAILSPHONENUMBER';
  contactDetails.emailID = 'CONTACT_BASICDETAILSEMAIL';
  if (isEnglish) {
    contactDetails.kelaID = 'CONTACT_BASICDETAILSKELA';
    contactDetails.permanentResidenceInFinlandID = 'CONTACT_PERMANENTRESIDENCEINFINLAND';
    contactDetails.nationalityID = 'CONTACT_NATIONALITY';
  }
  contactDetails.additionalInfoID = 'CONTACT_EXTRADETAILSADDITIONALINFO';

  const getValue = (answer) => {
    return answer || '';
  };

  useEffect(() => {
    if(contactDetails.loggedInUser) {
      searchCustomer(null)
    }
  }, [])

  return (
    <div>
      <Form spacing="default">
        <Row id="almost-ready">
          <IconLike size="default" />
          <p>
            <Message id="uiText.almost.ready" />
          </p>
        </Row>
        {contactDetails.loggedInUser ? (
          <List border="none" className="removeMargin">
            <ListItem
              dataKey="CONTACT_BASICDETAILFULLNAME"
              label={<Message id="labelText.FullName" />}
            >
              {`${getValue(contactDetails.firstName)} ${getValue(
                contactDetails.lastName
              )}`}
            </ListItem>
          </List>
        ) : (
          <React.Fragment>
            <FormInput
              type="string"
              autoComplete="given-name"
              value={getValue(contactDetails.firstName)}
              inputId="CONTACT_BASICDETAILFIRSTNAME"
              onChange={(firstName, error) => {
                contactDetails.firstName = firstName;
                validateContactInfo({
                  type: IO_CHANGE_CONTACTINFO,
                  questions: contactDetails,
                  questionId: 'CONTACT_BASICDETAILFIRSTNAME',
                  error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.FirstName')} - ${error?.message}`,
                  getMessage
                });
              }}
              label={getMessage('labelText.FirstName')}
              required
            />
            <FormInput
              type="string"
              autoComplete="family-name"
              value={getValue(contactDetails.lastName)}
              inputId="CONTACT_BASICDETAILLASTTNAME"
              onChange={(lastName, error) => {
                contactDetails.lastName = lastName;
                validateContactInfo({
                  type: IO_CHANGE_CONTACTINFO,
                  questions: contactDetails,
                  questionId: 'CONTACT_BASICDETAILLASTTNAME',
                  error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.LastName')} - ${error?.message}`,
                });
              }}
              label={getMessage('labelText.LastName')}
              required
            />

            <FormInput
              type="ssn-finland"
              autoComplete="off"
              value={getValue(contactDetails.idNumber)}
              inputId="CONTACT_BASICDETAILSSECURITYID"
              onChange={(idNumber, error) => {
                contactDetails.idNumber = idNumber.toUpperCase();
                validateContactInfo({
                  type: IO_CHANGE_CONTACTINFO,
                  questions: contactDetails,
                  questionId: 'CONTACT_BASICDETAILSSECURITYID',
                  error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.SecurityId')} - ${error?.message}`,
                });
              }}
              label={getMessage('labelText.SecurityId')}
              required
            />

          </React.Fragment>
        )}
                {isEnglish && <>
          <FormRow
            label={<Message id="labelText.BasicDetailsKela" />}
            labelFor="CONTACT_BASICDETAILSKELA"
            dataKey="CONTACT_BASICDETAILSKELA"
          >
            <SegmentedButton
              id="CONTACT_BASICDETAILSKELA"
              aria-describedby='BasicDetailsKelaError'
              value={getValue(contactDetails.kela)}
              
              name={`CONTACT_BASICDETAILSKELA-basicDetailsKela`}
              onChange={(e) => {
                contactDetails.kela = e.target.value;
                validateContactInfo({
                  type: IO_CHANGE_CONTACTINFO,
                  questions: contactDetails,
                  questionId: 'CONTACT_BASICDETAILSKELA',
                });
              }}
            >
              <Option value="Yes" key="Yes" required>
                {<Message id="option.yes" />}
              </Option>
              <Option value="No" key="No">
                {<Message id="option.no" />}
              </Option>
            </SegmentedButton>

            <ValidationError
              id="basicDetailsKelaError"
              requireVisible={false}
              errorId="CONTACT_BASICDETAILSKELA"
              errorMessageId="error.fill.in.missing.information"
            />
          </FormRow>

          <FormRow
            label={<Message id="labelText.BasicDetailsPermanentResidenceInFinland" />}
            labelFor="CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND"
            dataKey="CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND"
          >
            <SegmentedButton
              id="CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND"
              aria-describedby='BasicDetailsPermanentResidenceInFinlandError'
              value={getValue(contactDetails.permanentResidenceInFinland)}
              
              name={`CONTACT_BASICDETAILSKELA-basicDetailsPermanentResidenceInFinland`}
              onChange={(e) => {
                contactDetails.permanentResidenceInFinland = e.target.value;
                validateContactInfo({
                  type: IO_CHANGE_CONTACTINFO,
                  questions: contactDetails,
                  questionId: 'CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND',
                });
              }}
            >
              <Option value="Yes" key="Yes" required>
                {<Message id="option.yes" />}
              </Option>
              <Option value="No" key="No">
                {<Message id="option.no" />}
              </Option>
            </SegmentedButton>

            <ValidationError
              id="basicDetailsPermanentResidenceInFinlandError"
              requireVisible={false}
              errorId="CONTACT_BASICDETAILSPERMANENTRESIDENCEINFINLAND"
              errorMessageId="error.fill.in.missing.information"
            />
          </FormRow>
          <FormInput
            type="string"
            autoComplete="country-name"
            value={getValue(contactDetails.nationality)}
            maxLength={100}
            inputId="CONTACT_BASICDETAILSNATIONALITY"
            onChange={(nationality, error) => {
              contactDetails.nationality = nationality;
              validateContactInfo({
                type: IO_CHANGE_CONTACTINFO,
                questions: contactDetails,
                questionId: 'CONTACT_BASICDETAILSNATIONALITY',
                error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsNationality')} - ${error?.message}`,
              });
            }}
            label={getMessage('labelText.BasicDetailsNationality')}
            required
          />
        </>
        }
        <FormInput
          type="alphaNumeric"
          autoComplete="street-address"
          value={getValue(contactDetails.address)}
          inputId="CONTACT_BASICDETAILSADDRESS"
          onChange={(address, error) => {
            contactDetails.address = address;
            validateContactInfo({
              type: IO_CHANGE_CONTACTINFO,
              questions: contactDetails,
              questionId: 'CONTACT_BASICDETAILSADDRESS',
              error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsAddress')} - ${error?.message}`,
            });
          }}
          label={getMessage('labelText.BasicDetailsAddress')}
          required
        />

        <FormInput
          type='postal-code-finland'
          autoComplete="postal-code"
          value={getValue(contactDetails.postCode)}
          inputId="CONTACT_BASICDETAILPOSTCODE"
          onChange={(postCode, error) => {
            contactDetails.postCode = postCode;
            validateContactInfo({
              type: IO_CHANGE_CONTACTINFO,
              questions: contactDetails,
              questionId: 'CONTACT_BASICDETAILPOSTCODE',
              error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsPostCode')} - ${error?.message}`,
            });
          }}
          label={getMessage('labelText.BasicDetailsPostCode')}
          required
        />

        <FormInput
          type="string"
          autoComplete="address-level2"
          value={getValue(contactDetails.post)}
          inputId="CONTACT_BASICDETAILSPOST"
          onChange={(post, error) => {
            contactDetails.post = post;
            validateContactInfo({
              type: IO_CHANGE_CONTACTINFO,
              questions: contactDetails,
              questionId: 'CONTACT_BASICDETAILSPOST',
              error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsPost')} - ${error?.message}`,
            });
          }}
          label={getMessage('labelText.BasicDetailsPost')}
          required
        />

        <FormInput
          type='phone-number'
          autoComplete="tel"
          value={getValue(contactDetails.phoneNumber)}
          inputId="CONTACT_BASICDETAILSPHONENUMBER"
          onChange={(phoneNumber, error) => {
            contactDetails.phoneNumber = phoneNumber;
            validateContactInfo({
              type: IO_CHANGE_CONTACTINFO,
              questions: contactDetails,
              questionId: 'CONTACT_BASICDETAILSPHONENUMBER',
              error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsPhoneNumber')} - ${error?.message}`,
            });
          }}
          label={getMessage('labelText.BasicDetailsPhoneNumber')}
          hint={
            <PopupHint placement="top">
              <Message id="hintText.phoneNumberContactInfo" />
            </PopupHint>
          }
          required
        />

        <FormInput
          type='email'
          autoComplete="email"
          value={getValue(contactDetails.email)}
          inputId="CONTACT_BASICDETAILSEMAIL"
          onChange={(email, error) => {
            contactDetails.email = email;
            validateContactInfo({
              type: IO_CHANGE_CONTACTINFO,
              questions: contactDetails,
              questionId: 'CONTACT_BASICDETAILSEMAIL',
              error: error?.message && `${getMessage('labelText.ContactInfo')} : ${getMessage('labelText.BasicDetailsEmail')} - ${error?.message}`,
            });
          }}
          label={getMessage('labelText.BasicDetailsEmail')}
          required
        />

      </Form>
      <Form stacked spacing="default">
        <FormRow
          dataKey="CONTACT_EXTRADETAILSADDITIONALINFO"
          labelFor="CONTACT_EXTRADETAILSADDITIONALINFO"
          label={<Message id="labelText.ExtraDetailsAdditionalInfo" />}
          hint={
            <PopupHint placement="top">
              <Message id="hintText.extra.information" />
            </PopupHint>
          }
        >
          <p className="additionalInfoMessageText" id="additionalInfoText">
            <Message id="uiText.additionalInfoMessage" />
          </p>
          <ValidInput
            counter
            rows={4}
            autosize
            maxLength={500}
            value={getValue(contactDetails.additionalInfo)}
            name={`CONTACT_EXTRADETAILSADDITIONALINFO-ExtraDetailsAdditionalInfo`}
            aria-describedby="additionalInfoText"
            onChange={(e) => {
              let inputValue = e.target.value;
              // Replace special characters with empty space
              inputValue = inputValue.replace(/[~\\|:]/gi, ' ');
              contactDetails.additionalInfo = inputValue;
              validateContactInfo({
                type: IO_CHANGE_CONTACTINFO,
                questions: contactDetails,
                questionId: e.target.id,
              });
            }}
            id="CONTACT_EXTRADETAILSADDITIONALINFO"
          />
        </FormRow>
      </Form>
    </div>
  );
};

export default ContactInfo;
